
export class MemberConstants {
    static STR_IS_DONE_STEP_CHOOSE_REGISTER = 'is_done_step_choose_register'
    static STR_IS_DONE_STEP_1 = 'is_done_step_1'
    static STR_IS_DONE_STEP_2 = 'is_done_step_2'
    static STR_IS_DONE_STEP_3 = 'is_done_step_3'
    static STR_IS_DONE_STEP_4 = 'is_done_step_4'
    
    static STR_IS_CHECK_REGISTER = 'str_is_check_register'
    static STR_RID = 'rId'
    static STR_USERID_PARAM = 'userIdParam'
    static STR_PID_PARAM = 'pIdParam'
    static STR_ACCOUNT = "account"

    static URL_MEMBER_INQUIRY ='/my-office/member-management/member-infor-inquiry'

    static URL_CHOOSE_REGISTER ='/my-office/member-management/choose-member-register'
    static URL_STEP1 ='/my-office/member-management/member-regis-1'
    static URL_STEP2 ='/my-office/member-management/member-regis-2'
    static URL_STEP3 ='/my-office/member-management/member-regis-3'
    static URL_STEP4 ='/my-office/member-management/member-regis-4'
    static URL_STEP5 ='/my-office/member-management/member-regis-5'
    static URL_MYOFFICE = '/my-office/member-management/member-infor-inquiry'
    static CERTIFY_METHOD ='11'
    
    static USER_KIND_MEMBER ='U10'
    static USER_KIND_CONSUMER ='U00'

    

    // static STR_SM_CONFIG = "SM_CONFIG";
    // static STR_SM_WOWNET_PG = "STR_SM_WOWNET_PG";
    static readonly STR_IS_DONE_STEP_PREFIX = 'is_done_step_';


  }